// routes/_app.payment.landing.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.payment.landing')

export const handle = {
  name: 'payment/landing',
  hideMembershipBanner: true,
  showCreditPill: true,
}

export default dynamic(getClientModule, { ssr: false })
